import { Component, Vue, Prop } from 'vue-property-decorator'

@Component

export default class Table extends Vue {

  @Prop()
  private tableHead!: any;

  @Prop()
  private tableBody!: any;

  private formatTableData(index: string, data: string | number) {

    if (index === 'dimension') {
      
      const selector = (data as string).split(' ').join('').toString().toLowerCase();

      if (this.$te(`analytics.${selector}`)) {
  
        return this.$t(`analytics.${selector}`, {default: selector}) as string;
      }

      return data;
    }

    if (index === 'pageViews') {

      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    if (index === 'pageViewsPerSession') {

      return (data as number).toFixed(1);
    }

    if (index === 'averageSessionDuration') {
      let secs = data as number,
        minutes = Math.floor(secs / 60);

      secs = secs % 60;
      minutes = minutes % 60;

      return `${minutes < 10 ? '0' + minutes : minutes}${this.$t('time.minutes')}${secs < 10 ? '0' + secs.toFixed(0) : secs.toFixed(0)}${this.$t('time.seconds')}`;
    }

    if (index === 'ctr') {

      return (data as number).toFixed(1) + '%';
    }

    if (index === 'cpc') {

      return Math.round(data as number) + ' kr';
    }

    if (index === 'goalCompletions') {

      return Math.round(data as number).toFixed(1);
    }

    if (index === 'transactionsPerSession') {

      return data + '%';
    }

    if (index === 'transactionRevenue') {

      return Math.round(data as number) + ' kr';
    }

    return data;
  }
}
